import React, { useState, useEffect, useRef } from "react";
import Tiffins from "../../../images/products/all items.jpg";
import WaitermenuIteams from "./WaitermenuIteams";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Foodandbeveragesadvertise from "../FoodandBeverages/Foodandbeveragesadvertise";
import { useLoader } from "../../../context/LoaderProvider.jsx";
import { Link } from "react-router-dom";

const Waitermenu = () => {
    const [activeCategory, setActiveCategory] = useState("");
    const [parentId, setParentId] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [quantities, setQuantities] = useState({}); // Track quantities of items
    const [showPopup, setShowPopup] = useState(false);
    const [popupItem, setPopupItem] = useState(null);
    const [items, setItems] = useState([]); // Store API data
    // const [quantities, setQuantities] = useState({}); // Manage quantity state
    const [categories, setCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [dishes, setDishes] = useState([]);  // Added state for dishes
    // const [parentId, setParentId] = useState(null);
    const [posts, setPosts] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { showLoader, hideLoader } = useLoader();
    const [containerWidth, setContainerWidth] = useState(
        window.innerWidth > 1320 ? '180px' : window.innerWidth > 1000 ? '140px' : '100px'
    );

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1320) {
                setContainerWidth('180px');
            } else if (window.innerWidth > 1000) {
                setContainerWidth('140px'); // 👈 smaller width between 1000–1320px
            } else {
                setContainerWidth('100px');
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId) {
            console.warn("⚠️ vendorId not found in localStorage");
            return;
        }

        if (!token) {
            console.warn("⚠️ authToken not found in localStorage");
            return;
        }
        showLoader();
        fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setItems(data); // Set all data without filtering
            })
            .catch((error) => console.error("Error fetching data:", error)).finally(() => {
                hideLoader();
            })
    }, []);



    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId) {
            console.warn("⚠️ vendorId not found in localStorage");
            return;
        }

        if (!token) {
            console.warn("⚠️ authToken not found in localStorage");
            return;
        }

        fetch(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                // Filter categories where parentId is 0 or null
                const filteredCategories = data.filter((item) => item.parentId === 0 || item.parentId === null);

                // Filter all dishes where parentId is not 0 or null
                const allDishes = data.filter((item) => item.parentId !== 0 && item.parentId !== null);

                // Set the filtered categories and dishes in state
                setCategories(filteredCategories);
                setDishes(allDishes);
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, []);




    const handleClick = (categoryName) => {
        console.log(`Clicked on category: ${categoryName}`);

        if (categoryName === 'Allitems') {
            setParentId(null);
            setActiveCategory('Allitems');
            console.log('Selected parentId: null (All items selected)');
            return;
        }

        const selectedCategory = categories.find(
            category => category.dishName.trim().toLowerCase() === categoryName.trim().toLowerCase()
        );

        if (selectedCategory) {
            console.log(`Selected parentId: ${selectedCategory.dishId}`);
            setParentId(selectedCategory.dishId);
            setActiveCategory(categoryName);

            // Display matching dishes
            const matchingDishes = dishes.filter(
                dish => dish.parentId === selectedCategory.dishId
            );
            console.log(`Dishes for parentId ${selectedCategory.dishId}:`, matchingDishes);
        } else {
            console.log('Category not found');
            setParentId(null);
            setActiveCategory('Allitems');
        }
    };



    const navigate = useNavigate();


    // Automatically activate the first item from backend data
    useEffect(() => {
        if (categories.length > 0) {
            setActiveCategory("Allitems"); // Default to "Allitems"
        }
    }, [categories]);



    const currentCategoryItems = categories[activeCategory] || [];

    const filteredItems = currentCategoryItems.filter((item) => {
        if (isVegSelected) return item.type === "Veg";
        if (isNonVegSelected) return item.type === "Non-veg";
        return true;
    });

    const addToCarts = (id) => {
        setQuantities((prev) => ({ ...prev, [id]: 1 })); // Set initial quantity to 1
        setPopupItem(filteredItems.find((item) => item.id === id)); // Store clicked item
        setShowPopup(true);
    };

    const increaseQuantity = (id) => {
        setQuantities((prev) => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
    };

    const decreaseQuantity = (id) => {
        setQuantities((prev) => {
            const newQuantity = (prev[id] || 0) - 1;
            if (newQuantity <= 0) {
                const updatedQuantities = { ...prev };
                delete updatedQuantities[id]; // Remove item if quantity is 0
                return updatedQuantities;
            }
            return { ...prev, [id]: newQuantity };
        });
    };


    const scrollContainerRef = useRef(null);




    useEffect(() => {
        const vendorId = localStorage.getItem("vendorId");

        if (!vendorId) {
            console.warn("⚠️ vendorId not found in localStorage");
            return;
        }

        axios.get(`https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`)
            .then((response) => {
                const allDishes = response.data;

                // Filter for dishes with the name "Combos"
                const combos = allDishes.filter(dish => dish.dishName === "Combos");

                // Find child dishes with matching parentId
                const filteredData = allDishes.filter(dish =>
                    combos.some(combo => combo.dishId === dish.parentId)
                );

                setPosts(filteredData);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);





    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1; // Scroll down smoothly

                    // Infinite loop logic
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0; // Reset to top for seamless loop
                    }
                }
            }, 20); // Adjust speed by changing interval
        };

        startScrolling();

        return () => clearInterval(interval);
    }, [isHovered]);



    return (
        <>
            <div className="container-fluid">
                <div className="row " style={{ marginTop: "38px" }}>
                    <div className="col-lg-2 col-md-3 col-sm-12 col-12">

                        <div
                            style={{
                                maxHeight: "600px",
                                position: "sticky",
                                top: "0px",
                                marginTop: "67px",
                                zIndex: 1000,
                                // width: "180px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",

                            }}

                            // className="menu-categroy-data"
                            className="menu-side-scroll"
                        >


                            {isMobile ? (
                                <select
                                    onChange={(e) => handleClick(e.target.value)}
                                    value={activeCategory}
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "10px",
                                        background: "rgb(177 93 198)",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        border: "1px solid #ccc",
                                        marginBottom: "10px",
                                        // Make sure the marginLeft isn't causing overflow or the dropdown to be hidden
                                        marginLeft: "0px", // Temporarily remove margin for testing
                                    }}
                                >
                                    <option value="Allitems">All</option>
                                    {categories.map((category) => (
                                        <option key={category.dishId} value={category.dishName}>
                                            {category.dishName}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                // Card Layout for Desktop View
                                <div
                                    style={{
                                        overflowY: "auto",
                                        height: "550px",
                                        marginTop: "96px",
                                        scrollbarWidth: "none",
                                        width: containerWidth,
                                    }}
                                >

                                    {/* "Allitems" Category Card */}
                                    <div
                                        className="card"
                                        onClick={() => handleClick("Allitems")}
                                        style={{
                                            backgroundColor: activeCategory === "Allitems" ? "rgb(177 93 198)" : "#D9D9D9",
                                            marginTop: "4px",
                                            padding: "0px",
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            cursor: "pointer",
                                            zIndex: "1", // Corrected zIndex for proper click behavior
                                        }}
                                    >
                                        <img
                                            src={Tiffins}
                                            className="card-img-top"
                                            alt="Allitems"
                                            style={{
                                                borderRadius: "50%",
                                                width: "100px",
                                                height: "100px",
                                                display: "block",
                                                margin: "5px auto 0",
                                            }}
                                        />
                                        <br />
                                        <div className="card-body d-flex justify-content-center p-0">
                                            <button
                                                style={{
                                                    borderRadius: "10px",
                                                    marginTop: "-5px",
                                                    fontSize: "14px",
                                                    padding: "5px 10px",
                                                    width: "100px",
                                                    marginBottom: "5px",
                                                    background: "#fff",
                                                    color: "#000",
                                                    fontWeight: "bold",
                                                    border: "0px",
                                                }}
                                            >
                                                All
                                            </button>
                                        </div>
                                    </div>

                                    {/* Dynamic Categories from API */}
                                    {categories.map((category) => (
                                        <div
                                            key={category.dishId}
                                            className="card"
                                            onClick={() => handleClick(category.dishName)}
                                            style={{
                                                backgroundColor: activeCategory === category.dishName ? "rgb(177 93 198)" : "#D9D9D9",
                                                marginTop: "10px",
                                                padding: "0px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                height: "165px",
                                            }}
                                        >
                                            <img
                                                className="card-img-top"
                                                src={category.dishImage}
                                                alt={category.dishName}
                                                style={{
                                                    borderRadius: "50%",
                                                    width: "100px",
                                                    height: "98px",
                                                    display: "block",
                                                    margin: "5px auto 0",
                                                    background: "#000",
                                                    color: "#fff",
                                                }}
                                            />
                                            <br />
                                            <div className="card-body d-flex justify-content-center p-0">
                                                <button
                                                    style={{
                                                        borderRadius: "10px",
                                                        marginTop: "-5px",
                                                        fontSize: "14px",
                                                        padding: "5px 10px",
                                                        background: "#fff",
                                                        color: "#000",
                                                        width: "100px",
                                                        marginBottom: "5px",
                                                        fontWeight: "bold",
                                                        border: "0px",
                                                    }}
                                                >
                                                    {category.dishName}
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                        </div>
                    </div>

                    <div className="col-lg-7 col-md-7 col-sm-12 col-12">
                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: isMobile ? "50px" : "80px",
                                left: isMobile ? "5px" : "275px",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "14px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            {/* <Link
                                to="/Newmainlandingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link>
                            <span className="separator"> &gt; </span> */}
                            <Link
                                to="/foodladingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Table_Management
                            </Link>

                        </p>
                        <WaitermenuIteams parentId={parentId} />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                        <Foodandbeveragesadvertise />


                        {/* footer */}


                        {/* Chatbox Content */}

                    </div>
                </div>


            </div>
        </>
    );
};

export default Waitermenu;
